import React from 'react';
import { useHistory } from 'react-router'
import { makeStyles, Container, TextField, Typography, Grid, Dialog, Button, InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import customAxios from "../../components/API/customAxios";
import { useIntl } from 'react-intl';
import { DialogTitle, globalDialogStyle, messageBoxDialogStyle, DialogContent } from "./CommonStyle"
import { checkIsNewCompLeave } from '../Function/globalFunction';
import moment from 'moment';
import * as ErrorMessage from '../LeaveApplication/component/Form/DateValidErrorMessage';
import { SICK_LEAVE } from '../shared/Constant/LeaveTypes';

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...messageBoxDialogStyle(theme),
}));

export default function ConfirmBox({
    approveMode,
    leaveMode,
    approveId,
    handleClose,
    open,
    selectedRows,
    displayData,
    isApprove,
    editUpdatedAt,
    tabIndex,
    isNewCompLeave,
}) {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory()
    const [showAfterSubmittion, setShowAfterSubmittion] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [approvalText, setApprovalText] = React.useState();
    const [commentField, setCommentField] = React.useState(false);
    const [comment, setComment] = React.useState();
    const [confirmMessage, setConfirmMessage] = React.useState();
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    const [submitButtonText, setSubmitButtonText] = React.useState(intl.formatMessage({ id: 'waring.yes' }));
    const [commentSelect, setCommentSelect] = React.useState('');
    const [shrink, setShrink] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [redirectPage, setRedirectPage] = React.useState();
    const loadingTime = 3000;
    const isCompLeave = leaveMode === window.global.compLeaveRequest;

    const handleChangeSelect = (event) => {
        setComment(event.target.value);
        setShrink(true);
        setCommentSelect(event.target.value);
    };

    React.useEffect(() => {
        if (isApprove === 'approve') {
            setCommentField(false);
            setApprovalText(intl.formatMessage({ id: 'leave_approval.confirmation_approve' }));
            setConfirmMessage(intl.formatMessage({ id: 'leave_approval.approve_success_message' }));
        } else if (isApprove === 'reject') {
            setCommentField(true);
            setApprovalText(intl.formatMessage({ id: 'leave_approval.confirmation_reject' }));
            setConfirmMessage(intl.formatMessage({ id: 'leave_approval.reject_success_message' }));
        }

        // const leaveApprovalPath = isCompLeave ? '/compLeaveReqsApproval' : '/leave_approval';
        const leaveApprovalPath = '/leave_approval';
        switch (approveMode) {
            case window.global.myTeamApprove:
                setRedirectPage('/myteam')
                break;
            default:
                setRedirectPage(leaveApprovalPath)
                break;
        }
    }, [isApprove, approveMode])

    const handleChange = (event) => {
        setComment(event.target.value);
    };

    const handleFocus = () => {
        setShrink(true);
    };

    const handleBlur = (e) => {
        if (comment === undefined || comment === '') {
            setShrink(false);
        }
    };

    const returnMessage = (apiErrorMessage) => {
        if (apiErrorMessage) {
            setErrorMessage(intl.formatMessage({ id: "error." + apiErrorMessage }));
        } else  {
            setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
        }
    }

    const handleSubmit = async (selectIndex, data) => {
        setSubmitDisabled(true);
        setSubmitButtonText(intl.formatMessage({ id: 'waiting' }));

        if (approveMode === window.global.multipleApprove) {
            switch (isApprove) {
                case 'approve':
                    async function multipleApprove() {
                        var result = [];
                        for (var i = 0; i < selectIndex.length; i++) {
                            const isNewCompLeave = checkIsNewCompLeave(data[selectIndex[i].index].data[7]?.props?.children ?? data[selectIndex[i].index].data[7]);
                            const approvePath = isNewCompLeave ? '/approve_comp_leave_req/' : '/approve_leave/';

                            customAxios.post(approvePath + data[selectIndex[i].index].data[0])
                                .then(res => {
                                    result.push({
                                        status: res.data.code,
                                        message: res.data.message
                                    });
                                }).catch(error => {
                                    result.push({
                                        status: error.response.data.code,
                                        message: error.response.data.message
                                    });
                                }).then(() => {
                                    if (result.length === selectIndex.length) {
                                        setShowAfterSubmittion(true);
                                        if (result.some(el => el.status !== 201)) {
                                            setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
                                            setError(true);
                                            setTimeout(function () {
                                                setShowAfterSubmittion(false);
                                                handleClose();
                                            }, 6000);
                                        } else {
                                            setTimeout(function () {
                                                // history.push(redirectPage);
                                                history.push(
                                                    {
                                                        pathname: '/leave_approval',
                                                        search: tabIndex ? `?tabIndex=${tabIndex}` : `?tabIndex=${isCompLeave ? 1 : 0}`,
                                                    }
                                                );
                                                window.location.reload();
                                            }, loadingTime);
                                        }
                                    }
                                });
                        }
                    }
                    multipleApprove();
                    break;
                case 'reject':
                    async function rejectApprove() {
                        var result = [];
                        for (var i = 0; i < selectIndex.length; i++) {
                            const isNewCompLeave = checkIsNewCompLeave(data[selectIndex[i].index].data[7]?.props?.children ?? data[selectIndex[i].index].data[7]);
                            const rejectPath = isNewCompLeave ? '/reject_comp_leave_req/' : '/reject_leave/';

                            customAxios.post(rejectPath + data[selectIndex[i].index].data[0], {
                                id: approveId,
                                comment: comment,
                            })
                                .then(res => {
                                    result.push({
                                        status: res.data.code,
                                        message: res.data.message
                                    });
                                }, error => {
                                    result.push({
                                        status: error.response.data.code,
                                        message: error.response.data.message
                                    });
                                }).then(() => {
                                    if (result.length === selectIndex.length) {
                                        setShowAfterSubmittion(true);
                                        if (result.some(el => el.status !== 201)) {
                                            setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
                                            setError(true);
                                            setTimeout(function () {
                                                setShowAfterSubmittion(false);
                                                handleClose();
                                            }, 6000);
                                        } else {
                                            setTimeout(function () {
                                                // history.push(redirectPage);
                                                history.push(
                                                    {
                                                        pathname: '/leave_approval',
                                                        search: tabIndex ? `?tabIndex=${tabIndex}` : `?tabIndex=${isCompLeave ? 1 : 0}`,
                                                    }
                                                );
                                                window.location.reload();
                                            }, loadingTime);
                                        }
                                    }
                                });
                        }
                    }
                    rejectApprove()
                    break;
            }
        } else if (approveMode === window.global.singleApprove || approveMode === window.global.myTeamApprove) {
            const updatedAtPath = (isCompLeave || isNewCompLeave) ? '/get_comp_leave_req_updated_at/' : '/get_updated_at/';
            const approvePath = (isCompLeave || isNewCompLeave) ? '/approve_comp_leave_req/' : '/approve_leave/';
            const rejectPath = (isCompLeave || isNewCompLeave) ? '/reject_comp_leave_req/' : '/reject_leave/';
    
            switch (isApprove) {
                case 'approve':
                    customAxios.get(updatedAtPath + approveId)
                        .then(res => {
                            var getCurrentUpdateAt = res.data;
                            if (getCurrentUpdateAt === editUpdatedAt) {
                                customAxios.post(approvePath + approveId)
                                    .then(res => {
                                        setShowAfterSubmittion(true);
                                        setTimeout(function () {
                                            if (approveMode === window.global.singleApprove) {
                                                history.push(
                                                    {
                                                        pathname: '/leave_approval',
                                                        search: tabIndex ? `?tabIndex=${tabIndex}` : `?tabIndex=${isCompLeave ? 1 : 0}`,
                                                    }
                                                );
                                            } else if (approveMode === window.global.myTeamApprove) {
                                                history.push(redirectPage);
                                            }
                                            window.location.reload();
                                        }, loadingTime);
                                    }, error => {
                                        if (typeof error?.response?.data?.message?.update_result != "undefined") {
                                            handleClose();
                                            if (error?.response?.data?.message && error?.response?.data?.message?.leave_type === SICK_LEAVE) {
                                                alert(ErrorMessage.sickLeave(
                                                    intl,
                                                    error?.response?.data?.message,
                                                    'approve'
                                                ));
                                            } else {
                                                alert(ErrorMessage.annualLeave(
                                                    intl,
                                                    error?.response?.data?.message?.update_result,
                                                    error?.response?.data?.message?.exceeded
                                                ));
                                            }
                                            return;
                                        }
                                        if (error.response?.data?.message === 'some_need_approval_first') {
                                            handleClose();
                                            const oldestRecord = error.response?.data?.oldest_record;
                                            const startDate = moment(`${oldestRecord?.start_date} ${oldestRecord?.start_time}`).format(window.global.displayDateTimeFormat);
                                            const endDate = moment(`${oldestRecord?.until_date} ${oldestRecord?.end_time}`).format(window.global.displayDateTimeFormat);
                                            alert(intl.formatMessage({ id: 'error.some_need_approval_first' }, {startDate: startDate, endDate: endDate}));
                                            return;
                                        }
                                        setShowAfterSubmittion(true);
                                        console.log(error.response?.data?.message);
                                        returnMessage(error.response?.data?.message || 'An unexpected error occurred.');
                                        setError(true);
                                        setTimeout(function () {
                                            setShowAfterSubmittion(false);
                                            handleClose();
                                        }, 6000);
                                    });
                            } else {
                                alert(intl.formatMessage({ id: 'error.updated_please_refresh' }));
                            }
                        })
                    break;
                case 'reject':
                    customAxios.post(rejectPath + approveId, {
                        id: approveId,
                        comment: comment,
                    })
                        .then(res => {
                            setShowAfterSubmittion(true);
                            setTimeout(function () {
                                if (approveMode === window.global.singleApprove) {
                                    history.push(
                                        {
                                            pathname: '/leave_approval',
                                            search: tabIndex ? `?tabIndex=${tabIndex}` : `?tabIndex=${isCompLeave ? 1 : 0}`,
                                        }
                                    );
                                } else if (approveMode === window.global.myTeamApprove) {
                                    history.push(redirectPage);
                                }
                                window.location.reload();
                            }, loadingTime);
                        }, error => {
                            setShowAfterSubmittion(true);
                            console.log(error.response?.data?.message);
                            returnMessage(error.response?.data?.message || 'An unexpected error occurred.');
                            setError(true);
                            setTimeout(function () {
                                setShowAfterSubmittion(false);
                                handleClose();
                            }, 6000);
                        });
                    break;
            }
        }
    }
    return (
        <Container className={classes.container} variant="outlined">
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {intl.formatMessage({ id: 'confirmation' })}
                </DialogTitle>
                {!showAfterSubmittion ?
                    <DialogContent dividers>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {isCompLeave 
                                    ? <Typography>{intl.formatMessage({ id: 'comp_leave.confirmation_1' }) + approvalText + intl.formatMessage({ id: 'comp_leave.confirmation_2' })}</Typography>
                                    : <Typography>{intl.formatMessage({ id: 'leave_approval.confirmation_1' })}{approvalText}{intl.formatMessage({ id: 'leave_approval.confirmation_2' })}</Typography>
                                }
                            </Grid>
                            {commentField &&
                                <Grid item xs={12}>
                                    {leaveMode !== window.global.compLeaveRequest ? (
                                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                            <InputLabel>{intl.formatMessage({ id: 'leave_approval.reject_select_reason' })}</InputLabel>
                                            <Select
                                                value={commentSelect}
                                                onChange={handleChangeSelect}
                                                label="Select Reason"
                                            >
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_1' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_1' })}</MenuItem>
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_2' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_2' })}</MenuItem>
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_3' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_3' })}</MenuItem>
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_4' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_4' })}</MenuItem>
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_5' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_5' })}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                            <InputLabel>{intl.formatMessage({ id: 'leave_approval.reject_select_reason' })}</InputLabel>
                                            <Select
                                                value={commentSelect}
                                                onChange={handleChangeSelect}
                                                label="Select Reason"
                                            >
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_1' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_1' })}</MenuItem>
                                                <MenuItem value={intl.formatMessage({ id: 'leave_approval.reject_standard_reason_4' })}>{intl.formatMessage({ id: 'leave_approval.reject_standard_reason_4' })}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    <TextField
                                        key="Comment"
                                        variant="outlined"
                                        id="comment_id"
                                        name="comment"
                                        value={comment}
                                        label={intl.formatMessage({ id: 'comment' })}
                                        onChange={handleChange}
                                        multiline
                                        rows={2}
                                        fullWidth
                                        InputLabelProps={{ shrink: shrink }}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12}>
                                <div className={classes.yesButton}>
                                    <Button
                                        disabled={submitDisabled}
                                        variant="contained"
                                        style={{ backgroundColor: 'green', color: '#FFF' }}
                                        size="small"
                                        startIcon={<CheckCircleIcon />}
                                        onClick={e => { e.preventDefault(); handleSubmit(selectedRows, displayData) }}
                                    >
                                        {submitButtonText}
                                    </Button>
                                    <Button
                                        className={classes.noButton}
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        startIcon={<CancelIcon />}
                                        onClick={handleClose}
                                    >
                                        {intl.formatMessage({ id: 'waring.no' })}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    :
                    <DialogContent className={classes.afterSubmitPage} dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {!isError ? <Typography className={classes.title}>{confirmMessage}</Typography> : <Typography className={classes.title}>{errorMessage}</Typography>}
                            </Grid>
                            <Grid item xs={12}>
                                {!isError ? <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} /> : <CancelIcon color="secondary" style={{ fontSize: '100px' }} />}
                            </Grid>
                        </Grid>
                    </DialogContent>
                }
            </Dialog>
        </Container>
    )
}
